import React, { useState, useEffect } from "react";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert,Form } from 'react-bootstrap';
import { CDBCard, CDBDataTable, CDBContainer, CDBCardBody } from 'cdbreact';
import { FaEdit, FaTrash, FaPlus, FaArrowCircleLeft } from 'react-icons/fa';
import '../user/AllUser.css';
import {getCSinglePermission} from "../userRolePermission/rolepermissionAction";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../store";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { useParams} from 'react-router-dom';
import './rolepermission.css';
import { rolePermissionModification } from "../userRolePermission/rolepermissionAction";
import { getSingleUserRole } from "../userRole/UserRoleModifyAction";
import { FaUsers } from 'react-icons/fa';
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
import Button1 from '@mui/material/Button';


const MasterPage = () => {
    const [isAlive, setIsAlive] = useState(true);
    const [label, setLabel] = useState([]);
   
 
    
    const {combinedpermissiondetails,permissionisLoading} =useSelector((state)=> state.rolePermissionList);
    
    //console.log(city);
    const dispatch = useDispatch();
    const {id}=useParams();
   

    useEffect(() => {
        dispatch(getCSinglePermission(id));
        dispatch(getSingleUserRole(id));
     
            
    }, []);

    return (
        <Container>

            <div className="users">
                <RolePermissionList skey={combinedpermissiondetails} setIsAlive={setIsAlive}  />
            </div>
        </Container>
    );
}

const RolePermissionList = (props) => {

  const [expandedNodes, setExpandedNodes] = useState([]);
  const [change , setChange] = useState(true);
  const [permissionValues, setPermissionValues] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const {id}=useParams();
  let navigate = useNavigate();
  const {combinedpermissiondetails,permissionisLoading} =useSelector((state)=> state.rolePermissionList);
  const { isloading, mstatus, message, uroles } = useSelector((state) => state.userRoleModify);
  const [sortState, setSortState] = useState({
    // Initial sorting state for the disabled column
    label: {
      sort: false,
      sortOrder: null,
    },
  });
  
  useEffect(() => {
    if (combinedpermissiondetails.length > 0) {
      const updatedPermissionValues = combinedpermissiondetails
        .filter((obj) => obj.user_status === 1)
        .sort((a, b) => a.sort - b.sort)
        .map((item) => ({
          id: item.id,
          menuid: item.menu_id,
          view: item.menu_view === 1 ? 1 : 0,
          create: item.menu_add === 1 ? 1 : 0,
          modify: item.menu_edit === 1 ? 1 : 0,
          delete: item.menu_delete === 1 ? 1 : 0,
        }));
      setPermissionValues(updatedPermissionValues);
      console.log(updatedPermissionValues);
    }
  }, [combinedpermissiondetails]);
  
  const handleCheckboxChange = (menuId, field) => {
    setPermissionValues((prevValues) => {
      const updatedValues = prevValues.map((item) => {
        if (item.id === menuId) {
          return {
            ...item,
            [field]: item[field] === 1 ? 0 : 1,
          };
        }
        return item;
      });
      return updatedValues;
    });
    setChange(false)
  };
  
 
  const handleColumnCheckboxChange = (field) => {
    setPermissionValues((prevValues) =>
      prevValues.map((item) => ({
        ...item,
        [field]: selectAll ? 0 : 1,
      }))
    );
    setSelectAll(!selectAll);
    
    setChange(false)
  };
  
  
   
  const dispatch = useDispatch();
 

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const requests = permissionValues.map((item) => {
        const payload = {
          userroleid: id,
          menuid: item.menuid,
          menuview: item.view ? 1 : 0,
          menuadd: item.create ? 1 : 0,
          menuedit: item.modify ? 1 : 0,
          menudelete: item.delete ? 1 : 0,
        };
        return dispatch(rolePermissionModification(payload));
      });
  
      await Promise.all(requests);
  
      Swal.fire('Success', 'Role permissions updated successfully', 'success');
      navigate("/allRoles");
    } catch (error) {
      Swal.fire('Error', 'Failed to update role permissions', 'error');
    }
  };
  
  
 

  const data = () => {
    const parentNodes = combinedpermissiondetails.filter((obj) => obj.parent_id === 0 && obj.user_status === 1)
    .sort((a, b) => a.sort - b.sort)
    const rows = [];
  
    const renderChildNodes = (parentNode, isExpanded,index) => {
      const childNodes = combinedpermissiondetails.filter((obj) => obj.parent_id === parentNode.menu_id && obj.user_status === 1)
      .sort((a, b) => a.sort - b.sort)

      const parentViewChecked = permissionValues.find((item) => item.menuid === parentNode.menu_id)?.view;
      const parentRow = {
        
        label: (
          <div onClick={() => handleExpand(parentNode.menu_id)}>
            {childNodes.length > 0 && (isExpanded ? <FaAngleDown /> : <FaAngleRight />)}
            {parentNode.label}
          </div>
        ),
        view: (
          
          <input
            type="checkbox"
            checked={permissionValues.find((item) => item.menuid === parentNode.menu_id)?.view === 1}
            onChange={() => handleCheckboxChange(parentNode.id, 'view')}  
        
          />
        ),
        create: (
          <input
            type="checkbox"
            checked={permissionValues.find((item) => item.menuid === parentNode.menu_id)?.create === 1}
            onChange={() => handleCheckboxChange(parentNode.id, 'create')}
            disabled={parentViewChecked !== 1}
          />
        ),
        modify: (
          <input
            type="checkbox"
            checked={permissionValues.find((item) => item.menuid === parentNode.menu_id)?.modify === 1}
          onChange={() => handleCheckboxChange(parentNode.id, 'modify')}
          disabled={parentViewChecked !== 1}
          />
        ),
        delete: (
          <input
            type="checkbox"
            checked={permissionValues.find((item) => item.menuid === parentNode.menu_id)?.delete === 1}
          onChange={() => handleCheckboxChange(parentNode.id, 'delete')}
          disabled={parentViewChecked !== 1}
          />
        ),
      };
  
      rows.push(parentRow);
  
      if (isExpanded) {
        childNodes.forEach((childNode) => {
          const childViewChecked = permissionValues.find((item) => item.menuid === childNode.menu_id)?.view;
          const childRow = {
            label: (
              <div style={{ paddingLeft: "20px" }}>
                {childNode.label}
              </div>
            ),
            view: (
              <input
                type="checkbox"
                checked={permissionValues.find((item) => item.menuid === childNode.menu_id)?.view === 1}
              onChange={() => handleCheckboxChange(childNode.id, 'view')}
              disabled={parentViewChecked !== 1}
              
              />
            ),
            create: (
              <input
                type="checkbox"
                checked={permissionValues.find((item) => item.menuid === childNode.menu_id)?.create === 1}
                onChange={() => handleCheckboxChange(childNode.id, 'create')}
                disabled={childViewChecked !== 1 || parentViewChecked !== 1}
               
                
              />
            ),
            modify: (
              <input
                type="checkbox"
                checked={permissionValues.find((item) => item.menuid === childNode.menu_id)?.modify === 1}
              
              onChange={() => handleCheckboxChange(childNode.id, 'modify')}
              disabled={childViewChecked !== 1 || parentViewChecked !== 1}
            
              />
            ),
            delete: (
              <input
                type="checkbox"
                checked={permissionValues.find((item) => item.menuid === childNode.menu_id)?.delete === 1}
                
              onChange={() => handleCheckboxChange(childNode.id, 'delete')}
              disabled={childViewChecked !== 1 || parentViewChecked !== 1}
              />
            ),
          };
  
          rows.push(childRow);
        });
      }
    };
  
    const handleExpand = (menuId) => {
      setExpandedNodes((prevExpandedNodes) => {
        if (prevExpandedNodes.includes(menuId)) {
          return prevExpandedNodes.filter((nodeId) => nodeId !== menuId);
        } else {
          return [...prevExpandedNodes, menuId];
        }
      });
    };
  
    parentNodes.forEach((parentNode) => {
      const childNodes = combinedpermissiondetails.filter((obj) => obj.parent_id === parentNode.menu_id);
      const isExpanded = childNodes.length > 0 && expandedNodes.includes(parentNode.menu_id);
      renderChildNodes(parentNode, isExpanded);
    });
  
    return {
      columns: [
        {
          label: "Service Name",
          field: "label",
          width: 150,
          sort: false,
        },
        {
          label: (
            <div>
              <input
                type="checkbox"
                className="me-2"
                checked={selectAll}
                onChange={() => handleColumnCheckboxChange("view")}
              />
              View
            </div>
          ),
          field: "view",
          width: 100,
          sort: false,
        },
        {
          label: (
            <div>
              <input
                type="checkbox"
                className="me-2"
                checked={selectAll}
                onChange={() => handleColumnCheckboxChange("create")}
              />
              Create
            </div>
          ),
          field: "create",
          width: 100,
          sort: false,
        },
        {
          label: (
            <div>
              <input
                type="checkbox"
                className="me-2"
                checked={selectAll}
                onChange={() => handleColumnCheckboxChange("modify")}
              />
              Edit
            </div>
          ),
          field: "modify",
          width: 100,
          sort: false,
        },
        {
          label: (
            <div>
              <input
                type="checkbox"
                className="me-2"
                checked={selectAll}
                onChange={() => handleColumnCheckboxChange("delete")}
              />
              Delete
            </div>
          ),
          field: "delete",
          width: 100,
          sort: false,
        },
      ],
      rows: rows,
    };
  };
  
  
  
    return (
        <>
          <Card.Header  style={{marginTop:'-60px'}}><h2 className=" text-dark text-left mb-2 mt-3 role-name-list-head "   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>User Role Permission </h2> <div style={{ display: 'flex', justifyContent: 'flex-start' }}>{' '}</div> </Card.Header>
            <Container className="my-4  container-xl">

                <Card>
                <Card>
                <Card.Header> <Button1 variant='contained' style={{backgroundColor:'#d1af2b'}} onClick={() => navigate('/allRoles')}><FaArrowCircleLeft className="ml-2 me-2" />Back to User Role List
        </Button1></Card.Header>
                    <Form.Group as={Col} controlId="formGridUsername" className="mt-3 mb-3 ">
                  <Form.Label className="ms-3 role-name-list"><h5>User Role :</h5></Form.Label>
                  <Form.Control className="role-name-list-input" value={uroles.user_role} name="userrole" autoComplete='off'  style={{ width: "500px" }} readOnly/>
                
                </Form.Group>
                </Card>
                <Card.Header><h4>Permission Service List</h4></Card.Header>
                <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>
                    <Card.Body className="mt-3">
                       
                                    <CDBDataTable
                                         responsive
                                         bordered
                                         className="vertical-lines"
                                         hover
                                        scrollX
                                        scrollY                                    
                                        data={data()}
                                       paging={false}
                                        searching={false}
                                        sortable={false}
                                    />
                          
                    </Card.Body>
                    <div class="d-grid  col-2 mx-auto">
                    <Button
  variant="primary"
  type="submit"
  className="align-middle mt-3"
  style={{
    backgroundColor: "#003893",
    color: "white",
    border: "none",
    padding: "0.5rem 1rem",
    borderRadius: "0.25rem",
    transition: "background-color 0.3s ease",
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#002770")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "##1B3D6D")}
  disabled={change}
>
  Submit
</Button>
              </div>
              </Form>
                </Card>

            </Container>
        </>
    );
};
RolePermissionList.getLayout = (page) => (

    { page }

);

export default MasterPage;